import Gnb from './GnbNeo.vue';
export default Gnb;
